import { isCalendarSpread, isCross, isDelta1Multileg, isOptionStrategy } from '@talos/kyoko';
import { CmeStrategySummary } from './CmeStrategySummary';
import { DefaultMultilegSummary } from './DefaultMultilegSummary';
import type { MultiLegSummaryProps } from './types';

export function MultiLegSummary({
  security,
  side,
  readOnly,
  initiatingLegs,
  haircutRatios,
  legMarkets,
  legMarketSelectorItems,
  supportsAllMarkets,
  unifiedLiquidityToken,
  unifiedLiquidityMarkets,
  unifiedLiquidityMarketSelectorItems,
  touched,
  onEditSymbol,
  onUnifiedLiquidityMarketsChange,
  onLegMarketsChange,
  onInitiatingLegChange,
  onHaircutRatioChange,
  allocations,
  enableHaircutRatio,
  enableInPanelMarketSelectorLegSelection,
  isMarketSelectorNarrow,
  orderQuantity,
  orderCurrency,
  panelBottomSuffix,
}: MultiLegSummaryProps) {
  return (
    <>
      {isCalendarSpread(security) && <CmeStrategySummary security={security} />}
      {(isDelta1Multileg(security) || isCross(security) || isOptionStrategy(security)) && (
        <DefaultMultilegSummary
          security={security}
          side={side}
          readOnly={readOnly}
          legMarkets={legMarkets}
          initiatingLegs={initiatingLegs}
          haircutRatios={haircutRatios}
          legMarketSelectorItems={legMarketSelectorItems}
          unifiedLiquidityToken={unifiedLiquidityToken}
          unifiedLiquidityMarkets={unifiedLiquidityMarkets}
          unifiedLiquidityMarketSelectorItems={unifiedLiquidityMarketSelectorItems}
          supportsAllMarkets={supportsAllMarkets}
          touched={touched}
          onEditSymbol={onEditSymbol}
          onLegMarketsChange={onLegMarketsChange}
          onInitiatingLegChange={onInitiatingLegChange}
          onHaircutRatioChange={onHaircutRatioChange}
          onUnifiedLiquidityMarketsChange={onUnifiedLiquidityMarketsChange}
          allocations={allocations}
          enableHaircutRatio={enableHaircutRatio}
          enableInPanelMarketSelectorLegSelection={enableInPanelMarketSelectorLegSelection}
          isMarketSelectorNarrow={isMarketSelectorNarrow}
          orderQuantity={orderQuantity}
          orderCurrency={orderCurrency}
          panelBottomSuffix={panelBottomSuffix}
        />
      )}
    </>
  );
}
